import { BEIGE_300, BEIGE_600, WHITE } from 'constants/styling/theme'
import { Popper, PopperProps, autocompleteClasses, styled } from '@mui/material'

import React from 'react'

/**
 * @interface DropdownPopperProps Input properties
 * @extends PopperProps
 */
export interface DropdownPopperProps extends PopperProps {
  /** Dropdown popper id */
  id?: string
}

const StyledDropdownPopper = styled(Popper)(() => ({
  zIndex: 1,
  marginTop: '.4rem !important',
  [`& .${autocompleteClasses.paper}`]: {
    backgroundColor: WHITE,
  },
  [`& .${autocompleteClasses.listbox}`]: {
    padding: 'unset',
    [`& .${autocompleteClasses.option}`]: {
      '&[aria-selected="true"]': {
        backgroundColor: BEIGE_600,
      },
      [`&.${autocompleteClasses.focused}, &.${autocompleteClasses.focused}[aria-selected="true"]`]: {
        backgroundColor: BEIGE_300,
      },
    }
  },
  [`&. ${autocompleteClasses.popperDisablePortal}`]: {
    position: 'relative',
  },
}))

/**
 * @component MUI Dropdown Popper
 * @description A styled Popper component for dropdowns. The reason for using Popper is to not block the scrolling of the page when the dropdown is open.
 * @example
 * <MUIDropdownPopper />
 */
export const MUIDropdownPopper: React.FC<DropdownPopperProps> = ({
  id,
  ...props
}) => {

  return (
    <StyledDropdownPopper
      id={id}
      {...props}
    />
  )
}
